import { FunctionComponent, useState } from 'react'

import styled from 'styled-components'

import CollectionPolicyModal from 'app/components/Ballot/TermAndConditions/CollectionPolicyModal'
import CRATermsModal from 'app/components/Ballot/TermAndConditions/CraTermsModal'
import { Box, Button } from 'app/components/design-system-components'
import theme from 'app/match/applicationReportPDF/assets/theme'
import * as textHelpers from 'app/utils/text/helpers'

const StyledLearnMore = styled(Button)`
  font-size: ${theme.fontSizes.pLarge16};
`

type BallotTermAndConditionsProps = {
  teamSlug: string
}

const renderBallotTermsStart = () => (
  <Box>
    {textHelpers.VARC_BALLOT_APPLICATION_START_PAGE_TERM_AND_CONDITIONS.map(
      (text) => (
        <Box mb={2}>{text}</Box>
      ),
    )}
  </Box>
)

const ballotTermsTextDefault = (
  toggleCollectionPolicyModal: () => void,
  toggleCRATermsModal: () => void,
) => (
  <>
    <Box mt={2}>
      Application and survey data is subject to the Homes Victoria Data
      Collection Policy{' '}
      <StyledLearnMore
        variant="linkBlueWithoutWeight"
        onClick={toggleCollectionPolicyModal}
      >
        learn more
      </StyledLearnMore>
    </Box>
    <Box mt={2}>
      {textHelpers.CRA_POLICY_TEXT}{' '}
      <StyledLearnMore
        variant="linkBlueWithoutWeight"
        onClick={toggleCRATermsModal}
      >
        learn more
      </StyledLearnMore>
    </Box>
  </>
)

const ballotTermsTextQldAffordable = (
  toggleCollectionPolicyModal: () => void,
) => (
  <>
    <Box mt={2}>
      Application and survey data is subject to the National Affordable Housing
      Data Collection Policy{' '}
      <StyledLearnMore
        variant="linkBlueWithoutWeight"
        onClick={toggleCollectionPolicyModal}
      >
        learn more
      </StyledLearnMore>
    </Box>
  </>
)

const ballotTermsTextMirvac = () => {
  return null
}

const renderBallotTermsText = (
  teamSlug: string,
  toggleCollectionPolicyModal: () => void,
  toggleCRATermsModal: () => void,
) => {
  switch (teamSlug) {
    case textHelpers.QLD_AFFORDABLE_TEAM_NAME:
      return ballotTermsTextQldAffordable(toggleCollectionPolicyModal)
    case textHelpers.MIRVAC_TEAM_NAME:
      return ballotTermsTextMirvac()
    default:
      return ballotTermsTextDefault(
        toggleCollectionPolicyModal,
        toggleCRATermsModal,
      )
  }
}

export const BallotTermAndConditions: FunctionComponent<BallotTermAndConditionsProps> =
  ({ teamSlug = '' }) => {
    const [craTermsModalOpen, setCraTermsModalOpen] = useState(false)
    const [collectionPolicyModalOpen, setCollectionPolicyModalOpen] =
      useState(false)
    const toggleCRATermsModal = () => {
      setCraTermsModalOpen(!craTermsModalOpen)
    }
    const toggleCollectionPolicyModal = () => {
      setCollectionPolicyModalOpen(!collectionPolicyModalOpen)
    }

    return (
      <Box mt={6}>
        <h4>Terms and Conditions</h4>
        <Box mt={4} mb={4}>
          {renderBallotTermsStart()}
          {renderBallotTermsText(
            teamSlug,
            toggleCollectionPolicyModal,
            toggleCRATermsModal,
          )}
          {craTermsModalOpen && (
            <CRATermsModal toggleCRATermsModal={toggleCRATermsModal} />
          )}
          {collectionPolicyModalOpen && (
            <CollectionPolicyModal
              toggleCollectionPolicyModal={toggleCollectionPolicyModal}
              teamSlug={teamSlug}
            />
          )}
        </Box>
      </Box>
    )
  }

export default BallotTermAndConditions
